// extracted by mini-css-extract-plugin
module.exports = {"hideOnMobile":"styles_hideOnMobile__tZ85J"};